<template>
  <div>
    <h4 @click="$emit('skip')" class="text-center" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="200">
      <span class="step-indicator" :class="completed ? 'completed': ''">
        {{ step }} <i class="fal fa-check" v-show="completed"></i>
      </span>
    </h4>
    <h1 class="main-head text-center" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="200">{{ title }}</h1>
    <hr class="hr-light mx-5" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="200" />
  </div>
</template>
<script>
export default {
  props: {
    section: {
      type: Object,
      required: true
    },
    step: {
      type: String,
      required: true
    }
  },
  computed: {
    completed() {
      return this.section.completed
    },
    title() {
      return this.$t('sections.' + this.section.title_key)
    }
  }
}
</script>
